"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxisSchema = exports.AxisFormatSchema = exports.AxisTypeSchema = void 0;
const zod_1 = require("zod");
exports.AxisTypeSchema = zod_1.z.enum(['time', 'category', 'scalar', 'overlay']);
exports.AxisFormatSchema = zod_1.z.enum([
    'percentage',
    'time',
    'string',
    'currency',
    'decimal',
    'integer',
]);
exports.AxisSchema = zod_1.z.object({
    key: zod_1.z.string(),
    label: zod_1.z.string(),
    type: exports.AxisTypeSchema,
    format: exports.AxisFormatSchema.nullable(),
});
//# sourceMappingURL=axisSchema.js.map